import { useState } from "react";

/**
 * INTEL CONSOLE v3 — top language bar (red, 26px high).
 * EN/FR are visual placeholders only; ES is the canonical language.
 */
export const LangBar = () => {
  const [lang, setLang] = useState<"es" | "en" | "fr">("es");

  return (
    <div className="hidden md:flex h-[26px] items-center justify-between px-4 lg:px-10 bg-primary text-white/85 font-mono text-[9px] uppercase tracking-[0.18em] select-none">
      <div className="flex items-center gap-3">
        <span className="inline-block w-1.5 h-1.5 rounded-full bg-white intel-pulse-green" />
        <span className="hidden lg:inline">SISTEMAS OPERATIVOS · CVE FEED ACTIVO · ENV PRODUCTION</span>
        <span className="lg:hidden">SISTEMAS OPERATIVOS · CVE FEED</span>
      </div>
      <div className="flex items-center gap-2">
        {(["es", "en", "fr"] as const).map((l, i) => (
          <span key={l} className="flex items-center gap-2">
            <button
              onClick={() => setLang(l)}
              className={
                "px-1 transition-colors " +
                (lang === l ? "text-white font-semibold" : "text-white/55 hover:text-white")
              }
            >
              {l.toUpperCase()}
            </button>
            {i < 2 && <span className="text-white/30">|</span>}
          </span>
        ))}
      </div>
    </div>
  );
};
